<template>
  <form name="contract" class="needs-validation" novalidate>
    <div
      id="alert"
      class="alert alert-dismissible fade show m-alert m-alert--outline mb-4 mt-4"
      :class="alert.color"
      role="alert"
      v-if="alert.message"
      ref="alert"
    >
      <button type="button" class="close" aria-label="Close" @click="alert.message = ''"></button>
      <i :class="alert.icon"></i> &nbsp;<strong>{{ alert.message }}</strong
      ><br />
      {{ alert.reason }}
    </div>
    <label>Motivo da alteração <span class="m--font-danger">*</span></label>
    <input
      type="text"
      ref="change_reason"
      class="form-control"
      maxlength="255"
      v-model="data.change_reason"
      placeholder="Motivo da alteração"
    />
    <hr />

    <div class="row mb-4" v-if="this.contractId != 'add'">
      <div class="col-md-3">
        <label>Status do Contrato</label>
        <div class="input-group">
          <SelectContractsStatus
            :selected="data.status"
            @change="onChangeStatus($event)"
          ></SelectContractsStatus>
        </div>
      </div>
    </div>

    <div class="row">
      <div class="col-md-2">
        <div class="form-group">
          <label for="contract_id"> ID Plano </label>
          <div class="input-group">
            <input type="number" class="form-control m-input" v-model="data.id" readonly />
          </div>
        </div>
      </div>
      <div class="col-md-7">
        <div class="form-group" :class="{ 'has-danger': !data.customer_id }">
          <label>Cliente <span v-if="!data.id" class="m--font-danger">*</span></label>
          <div class="input-group">
            <SelectCustomers
              ref="customer_id"
              :selected="data.customer_id"
              :first="'Selecione um cliente'"
              @change="data.customer_id = $event"
              :disabled="!!data.id"
            />
          </div>
        </div>
      </div>
    </div>
    <div class="row mt-3">
      <div class="col-md-5">
        <div class="form-group" :class="{ 'has-danger': !data.product_id }">
          <label>Produto <span v-if="!data.id" class="m--font-danger">*</span></label>
          <div class="input-group">
            <SelectProducts
              ref="product_id"
              :selected="data.product_id"
              :first="'Selecione um produto'"
              @change="data.product_id = $event"
              :disabled="data.id"
              :productsNotAppear="[2, 3, 4, 5, 6]"
            />
          </div>
        </div>
      </div>
      <div class="col-md-5">
        <div class="form-group" :class="{ 'has-danger': !data.plan_id }">
          <label>Plano <span v-if="!data.id" class="m--font-danger">*</span></label>
          <div class="input-group">
            <SelectPlans
              ref="plan_id"
              :selected="data.plan_id"
              :first="'Selecione o plano'"
              :productId="data.product_id"
              @change="data.plan_id = $event"
            />
          </div>
        </div>
      </div>
    </div>
    <div class="row mt-3">
      <div class="col-md-4">
        <div class="form-group" :class="{ 'has-danger': !data.due_day && !data.due_in_days }">
          <label for="due_day"
            >Dia do vencimento <span class="m--font-danger">* </span
            ><i
              class="fas fa-info-circle info-icon"
              v-b-tooltip.html
              title="Dia do vencimento que será aplicado todo mês que gerar a fatura. <br>Exemplo:<br><b>Vencimento</b> 25<br><b>Faturamento dia</b> 01/10/2020<br>Vencimento da fatura será 25/10/2020"
            ></i
          ></label>
          <div class="input-group">
            <input
              id="due_day"
              oninput="this.value=this.value.slice(0,this.maxLength)"
              type="number"
              class="form-control m-input"
              step="1"
              min="1"
              max="30"
              maxlength="2"
              ref="due_day"
              v-model="data.due_day"
              required
            />
          </div>
        </div>
      </div>
      <div class="col-md-4">
        <div class="form-group" :class="{ 'has-danger': !data.start }">
          <label for="start">Início do contrato <span class="m--font-danger">*</span></label>
          <div class="input-group">
            <input
              id="start"
              type="date"
              max="9999-12-31"
              ref="start"
              class="form-control m-input"
              v-model="data.start"
              required
            />
          </div>
        </div>
      </div>
      <div class="col-md-4">
        <div class="form-group" :class="{ 'has-danger': data.finish && data.start > data.finish }">
          <label for="finish"
            >Fim do contrato
            <i
              class="fas fa-info-circle info-icon"
              v-b-tooltip
              title="Encerramento do contrato. Nenhuma fatura será gerada quando a data de 'Fim do contrato' for menor que a data de faturamento."
            ></i
          ></label>
          <div class="input-group">
            <input
              id="finish"
              type="date"
              ref="finish"
              max="9999-12-31"
              class="form-control m-input"
              v-model="data.finish"
            />
          </div>
        </div>
      </div>
    </div>

    <div class="row mt-3">
      <div class="col-md-3">
        <div class="form-group" :class="{ 'has-danger': !data.actual_contract_date }">
          <label for="start">Data atual do contrato <span class="m--font-danger">*</span></label>
          <div class="input-group">
            <input
              id="start"
              type="date"
              max="9999-12-31"
              ref="start"
              class="form-control m-input"
              v-model="data.actual_contract_date"
              required
            />
          </div>
        </div>
      </div>
      <div class="col-md-5">
        <div class="form-group" :class="{ 'has-danger': !data.due_day && !data.due_in_days }">
          <label for="due_date"
            >Prazo de vencimento <span class="m--font-danger">* </span>
            <i
              class="fas fa-info-circle info-icon"
              v-b-tooltip
              title="Prazo de vencimento sobrescreverá a regra de 'Dia do vencimento'. O vencimento será definido para X dias a partir do dia de faturamento."
            ></i
          ></label>
          <div class="input-group">
            <select
              class="form-control"
              v-model="data.due_in_days"
              @change="changedueInDays()"
              placeholder="asdads"
            >
              <option value="null">Selecione um prazo</option>
              <option
                v-for="contractDueOption in contractDueOptions"
                :key="contractDueOption"
                :value="contractDueOption"
              >
                {{ contractDueOption }} dias
              </option>
            </select>
            <small class="modified_field" v-if="data.due_in_days">
              <strong>Exemplo:</strong>
              <br />
              Faturamento hoje: {{ billingDateExample }} Vencimento dia:
              {{ dueDateExample }}
            </small>
          </div>
        </div>
      </div>
      <div class="col-md-4">
        <div class="form-group">
          <label for="finish"
            >Data de carência
            <i
              class="fas fa-info-circle info-icon"
              v-b-tooltip.html
              title="Data de quando iniciam as cobranças de um contrato.<br>Exemplo:<br><b>Contrato feito em  </b> 16/10/2020<br><b>Período de carência</b> 1 Mês<br> Data de carência será 16/11/2020"
            ></i
          ></label>
          <div class="input-group">
            <input
              id="finish"
              type="date"
              ref="finish"
              max="9999-12-31"
              class="form-control m-input"
              v-model="data.grace_date"
            />
          </div>
        </div>
      </div>
    </div>

    <div class="row mt-3">
      <div class="col-md-12">
        <label for="note">Observações</label>
        <div class="input-group">
          <input id="note" type="text" class="form-control" placeholder="" v-model="data.note" />
        </div>
      </div>
    </div>
    <div class="row mt-3" v-if="data.product_id == 7">
      <div class="col-md-12">
        <label for="note">Informações Chatbot</label>
        <div class="input-group">
          <input
            id="noteChatbot"
            type="text"
            class="form-control"
            placeholder=""
            v-model="data.note_chatbot"
          />
        </div>
      </div>
    </div>
    <hr class="row mt-5 mb-3" />
    <div class="row">
      <div class="col-md-12 text-right">
        <p class="p-0 m-0">
          <a
            href="#"
            @click.prevent="$refs.customer_id.$el.focus()"
            target="_self"
            class="m--font-danger"
            v-if="!data.customer_id"
            >O campo <strong>Cliente</strong> é obrigatório *</a
          >
        </p>
        <p class="p-0 m-0">
          <a
            href="#"
            @click.prevent="$refs.product_id.$el.focus()"
            target="_self"
            class="m--font-danger"
            v-if="!data.product_id"
            >O campo <strong>Produto</strong> é obrigatório *</a
          >
        </p>
        <p class="p-0 m-0">
          <a
            href="#"
            @click.prevent="$refs.plan_id.$el.focus()"
            target="_self"
            class="m--font-danger"
            v-if="!data.plan_id"
            >O campo <strong>Plano</strong> é obrigatório *</a
          >
        </p>
        <p class="p-0 m-0">
          <a
            href="#"
            @click.prevent="$refs.due_day.focus()"
            target="_self"
            class="m--font-danger"
            v-if="!data.due_day && (!data.due_in_days || data.due_in_days == 'null')"
            >O campo <strong>Dia ou Prazo de Vencimento </strong> precisam ser preenchidos *</a
          >
        </p>
        <p class="p-0 m-0">
          <a
            href="#"
            @click.prevent="$refs.due_day.focus()"
            target="_self"
            class="m--font-danger"
            v-if="data.due_day > 31"
            >O campo <strong>Dia de Vencimento</strong> não é valido *</a
          >
        </p>
        <p class="p-0 m-0">
          <a
            href="#"
            @click.prevent="$refs.start.focus()"
            target="_self"
            class="m--font-danger"
            v-if="!data.start"
            >O campo <strong>Início do contrato</strong> é obrigatório *</a
          >
        </p>
        <p class="p-0 m-0">
          <a
            href="#"
            @click.prevent="$refs.finish.focus()"
            target="_self"
            class="m--font-danger"
            v-if="data.finish && data.start > data.finish"
            ><strong>Início do contrato</strong> não pode ser maior que o
            <strong>Fim do contrato</strong></a
          >
        </p>
        <p class="p-0 m-0">
          <a
            href="#"
            @click.prevent="$refs.actual_contract_date.focus()"
            target="_self"
            class="m--font-danger"
            v-if="!data.actual_contract_date"
            >O campo <strong>Data atual do contrato</strong> é obrigatório *</a
          >
        </p>
        <p class="p-0 m-0">
          <a
            href="#"
            @click.prevent="$refs.change_reason.focus()"
            target="_self"
            class="m--font-danger"
            v-if="!data.change_reason"
            >O campo <strong>Motivo da alteração</strong> é obrigatório *</a
          >
        </p>
      </div>
    </div>
    <div class="row mb-5">
      <div class="col-md-12 text-right">
        <button
          @click.prevent="saveForm()"
          class="btn"
          :class="{ 'btn-metal': !formIsValid, 'btn-focus': formIsValid }"
          :disabled="!formIsValid || loading"
        >
          <i class="fas fa-save" v-if="formIsValid"></i>
          <i class="fas fa-exclamation-triangle" v-else></i>
          Salvar
        </button>
      </div>
    </div>
  </form>
</template>

<script>
import SelectCustomers from '@/components/forms/SelectCustomers';
import SelectProducts from '@/components/forms/SelectProducts';
import SelectPlans from '@/components/forms/SelectPlans';
import { returnMessageFormMixin } from '@/mixins/returnMessageFormMixin';
import moment from 'moment';
import { baseApiUrl } from '@/global';
import axios from 'axios';
import SelectContractsStatus from '../../forms/SelectContractStatus';

export default {
  mixins: [returnMessageFormMixin],
  name: 'CustomerContractPlanSaveForm',
  components: { SelectCustomers, SelectProducts, SelectPlans, SelectContractsStatus },
  props: {
    contract: {
      type: Object,
    },
    changeReason: String,
  },
  data() {
    const contractDueOptions = process.env.VUE_APP_CONTRACT_DUE_DATES.split(',');
    return {
      contractDueOptions,
      dueDateExample: '',
      billingDateExample: moment().format('DD/MM/YYYY'),
      data: {},
      loading: false,
    };
  },
  methods: {
    onChangeStatus(status) {
      this.data.status = status;
    },
    async saveForm() {
      await this.messageWaitingSave();

      const alertEl = this.$refs.alert;

      if (alertEl) {
        alertEl.scrollIntoView();
      }

      const { data } = this;

      this.loading = true;
      data.due_in_days = data.due_in_days != 'null' ? data.due_in_days : null;

      const url = `${baseApiUrl}/v1/customer/contract/plan/save`;
      axios
        .post(url, data)
        .then((res) => {
          this.logMessageForm(res);
          this.$store.state.showContractSave = res.data.item.id;
          this.$emit('savedContract', res.data.item);
          this.loading = false;
        })
        .catch((error) => {
          this.loading = false;
          this.logMessageFormFailed(error.response);
        });
    },
    changedueInDays() {
      this.dueDateExample = moment()
        .add(this.data.due_in_days, 'days')
        .format('DD/MM/YYYY');
    },
  },

  computed: {
    contractId() {
      return this.$store.state.showContractSave;
    },
    formIsValid() {
      if (
        this.data.customer_id &&
        this.data.product_id &&
        this.data.plan_id &&
        (this.data.due_day || (this.data.due_in_days && this.data.due_in_days != 'null')) &&
        this.data.start &&
        this.data.actual_contract_date &&
        this.data.due_day < 32 &&
        this.data.change_reason &&
        (!this.data.finish || this.data.start < this.data.finish)
      ) {
        return true;
      }
      return false;
    },
  },
  beforeMount() {
    if (this.contractId === 'add') {
      this.data = {
        customer_id: 0,
        product_id: 0,
        plan_id: 0,
        due_day: '',
        start: '',
        billing_method: 2,
        contract_type: 0,
        due_in_days: null,
        hired_by: 0,
      };
    }
  },
  watch: {
    contract(newContract) {
      this.data = newContract;
      this.changedueInDays();
    },
    changeReason() {
      this.data.change_reason = this.changeReason;
    },
  },
};
</script>

<style></style>
